import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import ruAuth from "./locales/ru/auth.json";
import ruCabinet from "./locales/ru/cabinet.json";
import ruCart from "./locales/ru/cart.json";
import ruCatalog from "./locales/ru/catalog.json";
import ruCheckout from "./locales/ru/checkout.json";
import ruCommon from "./locales/ru/common.json";
import ruFavorites from "./locales/ru/favorites.json";
import ruPayment from "./locales/ru/payment.json";
import ruShop from "./locales/ru/shop.json";
import uzAuth from "./locales/uz/auth.json";
import uzCabinet from "./locales/uz/cabinet.json";
import uzCart from "./locales/uz/cart.json";
import uzCatalog from "./locales/uz/catalog.json";
import uzCheckout from "./locales/uz/checkout.json";
import uzCommon from "./locales/uz/common.json";
import uzFavorites from "./locales/uz/favorites.json";
import uzPayment from "./locales/uz/payment.json";
import uzShop from "./locales/uz/shop.json";

export const LANGUAGES = ["ru", "uz"] as const;
export type Language = (typeof LANGUAGES)[number];

/** One file per language and feature. Russian is the reference: every key must exist there. */
export const resources = {
  ru: {
    common: ruCommon,
    auth: ruAuth,
    cabinet: ruCabinet,
    shop: ruShop,
    catalog: ruCatalog,
    cart: ruCart,
    checkout: ruCheckout,
    payment: ruPayment,
    favorites: ruFavorites,
  },
  uz: {
    common: uzCommon,
    auth: uzAuth,
    cabinet: uzCabinet,
    shop: uzShop,
    catalog: uzCatalog,
    cart: uzCart,
    checkout: uzCheckout,
    payment: uzPayment,
    favorites: uzFavorites,
  },
} as const;

const STORAGE_KEY = "ishonch.lang";

function initialLanguage(): Language {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === "ru" || saved === "uz") return saved;
  } catch {
    // storage unavailable (private mode) — fall back to the default
  }
  return "ru";
}

void i18n.use(initReactI18next).init({
  resources,
  lng: initialLanguage(),
  fallbackLng: "ru",
  defaultNS: "common",
  interpolation: { escapeValue: false }, // React already escapes
});

// <html lang> follows the language (screen readers, hyphenation), also after a reload in Uzbek
document.documentElement.lang = i18n.language;
i18n.on("languageChanged", (language) => {
  document.documentElement.lang = language;
});

export function setLanguage(language: Language) {
  try {
    localStorage.setItem(STORAGE_KEY, language);
  } catch {
    // ignore: the choice just won't survive a reload
  }
  void i18n.changeLanguage(language);
}

export { i18n };
